<template>
  <div v-if="registration">
    <ui-heading tag="h3" no-top-margin>
      {{ $t("registration_title") }}
    </ui-heading>
    <ui-field
      label-position="inline"
      :label="$t('registration.started')"
      bottom-margin="small"
    >
      {{ documentDateFormat(new Date(registration.started)) }}
    </ui-field>
    <ui-field
      label-position="inline"
      :label="$t('registration.finished')"
      bottom-margin="small"
    >
      {{ documentDateFormat(new Date(registration.finished)) }}
    </ui-field>
    <ui-field
      v-if="registration.companyName"
      label-position="inline"
      :label="$t('registration.company_name')"
      bottom-margin="small"
    >
      {{ registration.companyName }}
    </ui-field>
    <ui-field
      v-if="registration.companyCode"
      label-position="inline"
      :label="$t('registration.company_code')"
      bottom-margin="small"
    >
      {{ registration.companyCode }}
    </ui-field>
    <ui-field
      v-if="registration.phone"
      label-position="inline"
      :label="$t('registration.phone')"
      bottom-margin="small"
    >
      {{ registration.phone }}
    </ui-field>
    <ui-field
      v-if="registration.email"
      label-position="inline"
      :label="$t('registration.email')"
      bottom-margin="small"
    >
      {{ registration.email }}
    </ui-field>
    <ui-field
      v-if="registration.firstName"
      label-position="inline"
      :label="$t('registration.first_name')"
      bottom-margin="small"
    >
      {{ registration.firstName }}
    </ui-field>
    <ui-field
      v-if="registration.middleName"
      label-position="inline"
      :label="$t('registration.middle_name')"
      bottom-margin="small"
    >
      {{ registration.middleName }}
    </ui-field>
    <ui-field
      v-if="registration.lastName"
      label-position="inline"
      :label="$t('registration.last_name')"
      bottom-margin="small"
    >
      {{ registration.lastName }}
    </ui-field>
    <ui-field
      v-if="registration.dateOfBirth"
      label-position="inline"
      :label="$t('registration.date_of_birth')"
      bottom-margin="small"
    >
      {{ documentDateFormat(new Date(registration.dateOfBirth), false) }}
    </ui-field>
    <ui-field
      v-if="registration.personalCode"
      label-position="inline"
      :label="$t('registration.personal_code')"
      bottom-margin="none"
    >
      {{ registration.personalCode }}
    </ui-field>
    <ui-field
      v-if="registration.countryCode"
      label-position="inline"
      :label="$t('registration.country_code')"
      bottom-margin="small"
    >
      {{ registration.countryCode }}
    </ui-field>
    <ui-field
      v-if="registration.documentExpirationDate"
      label-position="inline"
      :label="$t('registration.document_expiration_date')"
      bottom-margin="small"
    >
      {{
        documentDateFormat(new Date(registration.documentExpirationDate), false)
      }}
    </ui-field>
    <ui-field
      v-if="registration.ipAddress"
      label-position="inline"
      :label="$t('registration.ip_address')"
      bottom-margin="small"
    >
      {{ registration.ipAddress }}
    </ui-field>
    <ui-field
      v-if="registration.ipCountryCode"
      label-position="inline"
      :label="$t('registration.ip_country_code')"
      bottom-margin="small"
    >
      {{ registration.ipCountryCode }}
    </ui-field>
    <ui-field
      v-if="registration.taxIdentificationNumber"
      label-position="inline"
      :label="$t('registration.taxIdentificationNumber')"
      bottom-margin="small"
    >
      {{ registration.taxIdentificationNumber }}
    </ui-field>
    <ui-field
      v-if="registration.countryOfBirth"
      label-position="inline"
      :label="$t('registration.countryOfBirth')"
      bottom-margin="small"
    >
      {{ $t(`countries.${registration.countryOfBirth}`) }}
    </ui-field>
    <ui-field
      v-if="registration.cityOfBirth"
      label-position="inline"
      :label="$t('registration.cityOfBirth')"
      bottom-margin="small"
    >
      {{ registration.cityOfBirth }}
    </ui-field>
    <ui-field
      v-if="registration.address"
      label-position="inline"
      :label="$t('registration.address')"
      bottom-margin="small"
    >
      {{ registration.address }}
    </ui-field>
    <ui-field
      v-if="registration.vatNumber"
      label-position="inline"
      :label="$t('registration.vatNumber')"
      bottom-margin="small"
    >
      {{ registration.vatNumber }}
    </ui-field>
    <ui-field
      v-if="registration.nationality"
      label-position="inline"
      :label="$t('registration.nationality')"
      bottom-margin="small"
    >
      {{ $t(`countries.${registration.nationality}`) }}
    </ui-field>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";
import { documentDateFormat } from "@/utils/date";

export default {
  computed: {
    ...mapGetters([getters.currentIdentification]),
    registration() {
      return this.currentIdentification?.data?.registration;
    },
    scores() {
      return this.currentIdentification?.data?.scores;
    }
  },
  methods: {
    documentDateFormat(date, includeTime) {
      return documentDateFormat(date, includeTime);
    }
  }
};
</script>
